import type * as React from 'react'
import { Rout_create } from './Rout.create'
import { Rout_to } from './Rout'
import { Rout_setBack } from './Rout.back'

export interface Rout_ActionRoutesArgs {
    Actn_UserActionsPage: React.FunctionComponent<unknown>
    Actn_ActionPage: React.FunctionComponent<unknown>
    Actn_NewAction: React.FunctionComponent<unknown>
    Actn_EditAction: React.FunctionComponent<unknown>
    Actn_ReportActionPage: React.FunctionComponent<unknown>
}

export const Rout_ActionRoutes = (args: Rout_ActionRoutesArgs) => [
    Rout_create('/actions', args.Actn_UserActionsPage),
    Rout_create('/action/:scheduledInstanceId', args.Actn_ActionPage),
    Rout_create('/action/:scheduledInstanceId/edit', args.Actn_EditAction),
    Rout_create('/report/:reportId/action/new', args.Actn_NewAction),
    Rout_create('/report/:reportId/action/:scheduledInstanceId/edit', args.Actn_EditAction),
    Rout_create('/report/:reportId/action/:scheduledInstanceId', args.Actn_ReportActionPage),
]

export function Rout_toUserActions() {
    Rout_to(`/actions`)
}

export function Rout_toActionSummary(
    scheduledInstanceId: string,
    back?: () => void,
    opts?: { markNotficationsAsRead?: boolean }
) {
    Rout_setBack(back)
    Rout_to(`/action/${scheduledInstanceId}`, opts)
}

export function Rout_toEditAction(scheduledInstanceId: string) {
    Rout_to(`/action/${scheduledInstanceId}/edit`)
}

export function Rout_toReportAction(reportId: number, scheduledInstanceId: string, back?: () => void) {
    Rout_setBack(back)
    Rout_to(`/report/${reportId}/action/${scheduledInstanceId}`)
}

export function Rout_toNewAction(reportId: number) {
    Rout_to(`/report/${reportId}/action/new`)
}

export function Rout_toEditReportAction(reportId: number, scheduledInstanceId: string) {
    Rout_to(`/report/${reportId}/action/${scheduledInstanceId}/edit`)
}
